"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMonth = exports.convertBillingPeriodToString = exports.getDateDifference = exports.getDateTimeNow = void 0;
var date_fns_1 = require("date-fns");
var getDateTimeNow = function () { return Date.now(); };
exports.getDateTimeNow = getDateTimeNow;
var getDateDifference = function (dateFrom, dateTo) {
    var newDateFrom = (0, date_fns_1.set)(dateFrom, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
    var newDateTo = (0, date_fns_1.set)(dateTo, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
    var differenceTime = newDateTo.getTime() - newDateFrom.getTime();
    return Math.ceil(differenceTime / (1000 * 3600 * 24));
};
exports.getDateDifference = getDateDifference;
var convertBillingPeriodToString = function (from, to) {
    var monthFrom = (0, exports.getMonth)(from.substring(5, 7));
    var monthTo = (0, exports.getMonth)(to.substring(5, 7));
    return "".concat(from.substring(8, 10).replace(/^0+/, ''), " ").concat(monthFrom.full, " \u2013 ").concat(to.substring(8, 10).replace(/^0+/, ''), " ").concat(monthTo.full);
};
exports.convertBillingPeriodToString = convertBillingPeriodToString;
var getMonth = function (month) {
    var date = new Date();
    // note day set to 1. Otherwise, if the current value is 31st January 2016, calling setMonth with a value of 1 will return
    // 2nd March 2016. This is because in 2016 February had 29 days.
    date.setMonth(Number(month) - 1, 1);
    var full = date.toLocaleString([], { month: 'long' });
    var abbr = date.toLocaleString([], { month: 'short' });
    return {
        full: full,
        abbr: abbr,
    };
};
exports.getMonth = getMonth;
//# sourceMappingURL=date.js.map